module.exports = __webpack_public_path__ + "mh.969819c2.svg";